import FileDownload from 'js-file-download'
import { toast } from 'react-toastify'
import { fetchSigns } from '../../utils/api/getSigns'
import { getLatestState } from './StoreData'

const FILE_TYPE = /(\.csv)$/i

const responseData = (response, file) =>
  FILE_TYPE.test(file) ? response : JSON.stringify(response)

export const downloadFile = async (headers, file) => {
  const toastId = toast.info('Download started.')
  const { mapCache, category, address, coordParams } = getLatestState()
  try {
    let response = await fetchSigns(
      coordParams,
      category[1],
      mapCache.radius,
      address,
      '',
      headers
    )
    if (response) {
      FileDownload(responseData(response.data, file), file)
      toast.update(toastId, {
        render: 'Download successful',
        type: toast.TYPE.SUCCESS,
        className: 'success-alert',
      })
    }
  } catch (err) {
    console.log(err, 'Error while Downloading File')
  }
}



// WEBPACK FOOTER //
// ./src/store/Actions/Downloads.js